import React from 'react'
import { useForm } from 'sb-formx'
import actions from  'redux/actions'
import storeData from 'sb-store-data'
import { constants } from 'common/helpers'
import { required, email } from 'helpers/validation'
import { useCallback, useWillMount } from 'sb-hooks'

import EmailField from 'components/_new/auth/EmailField/EmailField'
import { Button, buttonMessages } from 'components/_new/controls'
import Text from 'components/_new/typography/Text/Text'
import { Box } from 'components/_new/layout'

import messages from './messages'
import s from './RemindPasswordForm.scss'


const formOptions = {
  name: 'RemindPasswordForm',
  fields: {
    email: [ required, email ],
  },
}

const RemindPasswordForm = ({ authEmail, onClickBackLink }) => {
  const form = useForm(formOptions)

  const handleSubmit = useCallback((event) => {
    event.preventDefault()

    form.submit()
      .then(({ email }) => {
        actions.models.user.remindPassword(email, { withErrorModal: false })
          .then(() => {
            actions.models.modals.close(constants.modals.RemindPassword)

            actions.models.modals.open(constants.modals.Dialog, {
              buttonTitle: messages.btnClose,
              contentMessage: messages.confirmMessage,
            })
          })
      })
  }, [])

  useWillMount(() => {
    if (authEmail) {
      form.setInitialValues({ email: authEmail })
    }
  })

  return (
    <form
      id="remindPasswordForm"
      className={s.remindPasswordForm}
      onSubmit={handleSubmit}
    >
      <EmailField className={s.field} field={form.fields.email} standardView />
      <Box className={s.actions} pt={36}>
        <div className={s.linkBack} onClick={onClickBackLink}>
          <Text message={messages.linkBack} tag="span" />
        </div>
        <Button
          className={s.resetPassword}
          title={buttonMessages.resetPassword}
          color="brand"
          size="md"
          fullWidth
          uppercase
          dataTestId="resetPasswordButton"
          type="submit"
        />
      </Box>
    </form>
  )
}


export default storeData({
  authEmail: 'models.user.authEmail',
})(RemindPasswordForm)
